// Shared demo company; read-only for everyone except global admins.
export const DEMO_COMPANY_ID = 1;
